<!--
  - Copyright (c) 2025. Haodong JU
  -->

<template>
  <v-dialog
    v-model="isVisible"
    max-width="900px"
    persistent
    scrollable
  >
    <v-card>
      <v-toolbar flat dense color="transparent">
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          icon
          @click="cancel"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider></v-divider>

      <v-card-text class="pt-4">
        <member-selector
          ref="memberSelector"
          v-model="selectedMemberIds"
          :multiple="multiple"
          :return-mode="returnMode"
          @selection-confirmed="confirm"
        ></member-selector>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          text
          @click="cancel"
        >
          取消
        </v-btn>
        <v-btn
          color="primary"
          :disabled="selectedMemberIds.length === 0"
          @click="confirm"
        >
          确认选择
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import MemberSelector from './MemberSelector.vue'
import { useMemberSelectorDialogStore } from '@/model/dataLayer/api/memberSelectorDialogStore'
import { mapState } from 'pinia'

export default {
  name: 'GlobalMemberSelectorDialog',
  components: {
    MemberSelector
  },
  data () {
    return {
      selectedMemberIds: []
    }
  },
  computed: {
    ...mapState(useMemberSelectorDialogStore, [
      'isVisible',
      'title',
      'multiple',
      'initialSelection',
      'returnMode'
    ])
  },
  watch: {
    initialSelection: {
      immediate: true,
      handler (newValue) {
        if (newValue && Array.isArray(newValue)) {
          this.selectedMemberIds = [...newValue]
        }
      }
    }
  },
  methods: {
    confirm () {
      const store = useMemberSelectorDialogStore()
      store.confirmSelection([...this.selectedMemberIds])
    },

    cancel () {
      const store = useMemberSelectorDialogStore()
      store.cancelSelection()
    }
  }
}
</script>
